<template>
  <div class="card-guide">
    <div class="card-guide-body">
      <div class="d-flex justify-content-between">
        <span class="add-tags" @click="showAddTag">+ ADD TAG</span>
        <span class="search">
          <label>
            <svg
              width="16"
              height="17"
              viewBox="0 0 16 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.3335 3.16659C4.75617 3.16659 2.66683 5.25592 2.66683 7.83325C2.66683 10.4106 4.75617 12.4999 7.3335 12.4999C9.91083 12.4999 12.0002 10.4106 12.0002 7.83325C12.0002 5.25592 9.91083 3.16659 7.3335 3.16659ZM1.3335 7.83325C1.3335 4.51954 4.01979 1.83325 7.3335 1.83325C10.6472 1.83325 13.3335 4.51954 13.3335 7.83325C13.3335 11.147 10.6472 13.8333 7.3335 13.8333C4.01979 13.8333 1.3335 11.147 1.3335 7.83325Z"
                fill="#B3C2CB"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10.6284 11.1286C10.8887 10.8683 11.3108 10.8683 11.5712 11.1286L14.4712 14.0286C14.7315 14.289 14.7315 14.7111 14.4712 14.9714C14.2108 15.2318 13.7887 15.2318 13.5284 14.9714L10.6284 12.0714C10.368 11.8111 10.368 11.389 10.6284 11.1286Z"
                fill="#B3C2CB"
              />
            </svg>
            <input
              type="search"
              class="search-input"
              placeholder="Search Tag"
              v-model="searchStr"
            />
          </label>
        </span>
      </div>

      <div class="tags">
        <div class="tag" v-for="(tag, i) in tags" :key="i">
          {{ tag.text }}
          <div class="overlay">
            <svg
              @click="showEditTag(i)"
              v-b-popover.top.hover="'Edit Tag'"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.6665 3.33333C2.48969 3.33333 2.32012 3.40357 2.1951 3.5286C2.07008 3.65362 1.99984 3.82319 1.99984 4V13.3333C1.99984 13.5101 2.07007 13.6797 2.1951 13.8047C2.32012 13.9298 2.48969 14 2.6665 14H11.9998C12.1766 14 12.3462 13.9298 12.4712 13.8047C12.5963 13.6797 12.6665 13.5101 12.6665 13.3333V9.77333C12.6665 9.40514 12.965 9.10667 13.3332 9.10667C13.7014 9.10667 13.9998 9.40514 13.9998 9.77333V13.3333C13.9998 13.8638 13.7891 14.3725 13.4141 14.7475C13.039 15.1226 12.5303 15.3333 11.9998 15.3333H2.6665C2.13607 15.3333 1.62736 15.1226 1.25229 14.7475C0.877218 14.3725 0.666504 13.8638 0.666504 13.3333V4C0.666504 3.46957 0.877217 2.96086 1.25229 2.58579C1.62736 2.21071 2.13607 2 2.6665 2H6.2265C6.59469 2 6.89317 2.29848 6.89317 2.66667C6.89317 3.03486 6.59469 3.33333 6.2265 3.33333H2.6665Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11.5284 0.86201C11.7888 0.601661 12.2109 0.601661 12.4712 0.86201L15.1379 3.52868C15.3983 3.78903 15.3983 4.21114 15.1379 4.47149L8.47124 11.1382C8.34622 11.2632 8.17665 11.3334 7.99984 11.3334H5.33317C4.96498 11.3334 4.6665 11.0349 4.6665 10.6667V8.00008C4.6665 7.82327 4.73674 7.6537 4.86177 7.52868L11.5284 0.86201ZM5.99984 8.27622V10.0001H7.7237L13.7237 4.00008L11.9998 2.27622L5.99984 8.27622Z"
                fill="white"
              />
            </svg>
            <svg
              @click="showDeleteTag(i)"
              v-b-popover.top.hover="'Delete Tag'"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M1.3335 3.99992C1.3335 3.63173 1.63197 3.33325 2.00016 3.33325H14.0002C14.3684 3.33325 14.6668 3.63173 14.6668 3.99992C14.6668 4.36811 14.3684 4.66659 14.0002 4.66659H2.00016C1.63197 4.66659 1.3335 4.36811 1.3335 3.99992Z"
                fill="white"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.6665 2.00008C6.48969 2.00008 6.32012 2.07032 6.1951 2.19534C6.07007 2.32037 5.99984 2.48994 5.99984 2.66675V3.33341H9.99984V2.66675C9.99984 2.48994 9.9296 2.32037 9.80457 2.19534C9.67955 2.07032 9.50998 2.00008 9.33317 2.00008H6.6665ZM11.3332 3.33341V2.66675C11.3332 2.13631 11.1225 1.62761 10.7474 1.25253C10.3723 0.877462 9.8636 0.666748 9.33317 0.666748H6.6665C6.13607 0.666748 5.62736 0.877462 5.25229 1.25253C4.87722 1.62761 4.6665 2.13631 4.6665 2.66675V3.33341H3.33317C2.96498 3.33341 2.6665 3.63189 2.6665 4.00008V13.3334C2.6665 13.8638 2.87722 14.3726 3.25229 14.7476C3.62736 15.1227 4.13607 15.3334 4.6665 15.3334H11.3332C11.8636 15.3334 12.3723 15.1227 12.7474 14.7476C13.1225 14.3726 13.3332 13.8638 13.3332 13.3334V4.00008C13.3332 3.63189 13.0347 3.33341 12.6665 3.33341H11.3332ZM3.99984 4.66675V13.3334C3.99984 13.5102 4.07007 13.6798 4.1951 13.8048C4.32012 13.9298 4.48969 14.0001 4.6665 14.0001H11.3332C11.51 14.0001 11.6795 13.9298 11.8046 13.8048C11.9296 13.6798 11.9998 13.5102 11.9998 13.3334V4.66675H3.99984Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      </div>
      <modal :id="tagModal">
        <div class="add-tag" v-if="!del">
          <span class="close-icon" @click="$bvModal.hide(tagModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>

          <h3>{{ add ? "Add" : "Edit" }} Tag</h3>
          <div class="h-18"></div>
          <b-form-group>
            <b-form-input
              id="new-tag"
              type="text"
              required
              v-model="tagInput"
              placeholder="Enter your tag here"
              @focus="limitWords"
            ></b-form-input>
            <span class="counter">{{ tagInput.length }}/25</span>
          </b-form-group>

          <div class="d-flex justify-content-between">
            <b-button
              variant="light btn-simple"
              @click="$bvModal.hide(tagModal)"
            >
              Cancel
            </b-button>
            <b-button
              variant="primary btn-round-fill "
              v-if="add"
              @click="addTag"
              :disabled="tagInput.trim().length > 0 ? false : true"
            >
              Add
            </b-button>
            <b-button
              variant="primary btn-round-fill "
              @click="editTag"
              v-else
              :disabled="tagInput.trim().length > 0 ? false : true"
            >
              Update
            </b-button>
          </div>
        </div>
        <div class="add-tag del-tag" v-else>
          <span class="close-icon" @click="$bvModal.hide(tagModal)">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
              <g clip-path="url(#clip0)">
                <path
                  d="M12.5891 12.0006L17.2111 7.37855C17.3739 7.21582 17.3739 6.95199 17.2111 6.78928C17.0484 6.62657 16.7846 6.62655 16.6219 6.78928L11.9998 11.4113L7.37782 6.78928C7.21509 6.62655 6.95126 6.62655 6.78855 6.78928C6.62584 6.95201 6.62582 7.21584 6.78855 7.37855L11.4106 12.0006L6.78855 16.6226C6.62582 16.7853 6.62582 17.0492 6.78855 17.2119C6.8699 17.2932 6.97655 17.3339 7.0832 17.3339C7.18984 17.3339 7.29647 17.2932 7.37784 17.2119L11.9998 12.5899L16.6218 17.2119C16.7032 17.2932 16.8098 17.3339 16.9165 17.3339C17.0231 17.3339 17.1298 17.2932 17.2111 17.2119C17.3739 17.0491 17.3739 16.7853 17.2111 16.6226L12.5891 12.0006Z"
                  fill="#606770"
                />
              </g>
              <defs>
                <clipPath id="clip0">
                  <rect
                    width="10.6667"
                    height="10.6667"
                    fill="white"
                    transform="translate(6.6665 6.66675)"
                  />
                </clipPath>
              </defs>
            </svg>
          </span>
          <h3>Delete Tag</h3>
          <div class="warning-msg">
            <p>
              Are you sure want to delete
              <strong>
                {{ tags[activeIndex].text }}
              </strong>
              tag?
            </p>
          </div>
          <div class="d-flex justify-content-between">
            <b-button variant="danger btn-round-fill " @click="deleteTag">
              Yes! Delete
            </b-button>
            <b-button class="btn-simple" @click="hideDeleteTag">
              No! back
            </b-button>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import Modal from "@/components/common/modal";
export default {
  data() {
    return {
      tagModal: "tag-modal",
      searchStr: "",
      add: true,
      del: false,
      tagInput: "",
      activeIndex: -1,
      allTags: this.profile._dashboards.guide.tags
        ? JSON.parse(JSON.stringify(this.profile._dashboards.guide.tags))
        : []
    };
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Modal
  },
  computed: {
    tags() {
      if (this.searchStr.trim() == "") return this.allTags;

      return this.allTags.filter(tag => {
        return tag.text
          .toLowerCase()
          .includes(this.searchStr.toLowerCase().trim());
      });
    }
  },
  methods: {
    limitWords() {
      document.getElementById("new-tag").setAttribute("maxlength", 25);
    },
    getNested({ obj, def }, ...args) {
      let truthy = args.reduce((obj, level) => obj && obj[level], obj);
      if (truthy) {
        let val = Array.isArray(truthy) ? truthy : def;
        return val;
      } else {
        return def;
      }
    },
    showAddTag() {
      this.del = false;
      this.add = true;
      (this.tagInput = ""), this.$bvModal.show(this.tagModal);
    },
    showEditTag(i) {
      this.del = false;
      this.add = false;
      this.activeIndex = i;
      this.tagInput = this.tags[i].text;
      this.$bvModal.show(this.tagModal);
    },
    showDeleteTag(i) {
      this.del = true;
      this.activeIndex = i;
      this.$bvModal.show(this.tagModal);
    },
    addTag() {
      this.tags.push({
        text: this.tagInput,
        _created_at: new Date()
      });
      this.$bvModal.hide(this.tagModal);
      this.tagInput = "";
      this.saveChanges();
    },
    editTag() {
      this.tags[this.activeIndex].text = this.tagInput;
      this.$bvModal.hide(this.tagModal);
      this.tagInput = "";
      this.saveChanges();
    },
    deleteTag() {
      this.tags.splice(this.activeIndex, 1);
      this.$bvModal.hide(this.tagModal);
      this.saveChanges();
    },
    hideDeleteTag() {
      this.$bvModal.hide(this.tagModal);
    },
    saveChanges() {
      let dataToUpdateTags = {
        guide: {
          tags: this.tags
        }
      };

      if (dataToUpdateTags) {
        this.$store
          .dispatch("user/updateProfileDashboardGuide", dataToUpdateTags)
          .then(res => {
            if (res) {
              this.$store.dispatch("user/getProfile").then(() => {
                this.$store.dispatch("user/showNotification", {
                  title: "Tags Updated Successfully",
                  description:
                    "Users will not see this info until you Publish.",
                  variant: "success"
                });
              });
            }
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.add-tags {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  color: #557efb;
  cursor: pointer;
  position: relative;
}

.add-tag {
  .close-icon {
    position: absolute;
    top: 24px;
    right: 20px;
    cursor: pointer;
  }
  .btn-round-fill {
    max-width: 160px;
    width: 100%;
  }
  input {
    margin-top: 48px;
    margin-bottom: 30px;
  }
  h3 {
    margin-bottom: 0;
    margin-top: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
  }
}
.del-tag {
  .warning-msg {
    margin: 24px 0;
    p {
      text-align: center;
      margin: 0;
    }
  }
  .btn-round-fill {
    background-color: #ef5c4a;
    border-color: #ef5c4a;
  }
  .btn-simple {
    color: #ef5c4a;
    font-weight: bold;
  }
}

.search {
  cursor: pointer;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  color: #8d99a0;
}
.card-guide {
  box-shadow: none;
}

.tags {
  display: flex;
  margin-top: 20px;
  flex-wrap: wrap;
  .tag {
    min-width: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 12px 16px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 24px;
    margin-right: 16px;
    margin-top: 10px;
    font-size: 14px;
    line-height: 19px;
    align-items: center;
    color: #474d52;
    position: relative;
    .overlay {
      // visibility: hidden;
      opacity: 0;
      border-radius: 24px;
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.8);
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      transition: all 0.2s ease-in-out;
      svg {
        cursor: pointer;
      }
    }
    &:hover {
      .overlay {
        opacity: 1;
        // visibility: visible;
      }
    }
  }
}
.counter {
  margin-top: -18px;
  margin-right: 5px;
  font-size: 12px;
  float: right;
}
</style>
